<template>
  <b-modal
    v-model="localVisible"
    size="xl"
    :title="title"
    hide-footer
    header-bg-variant="primary"
    header-text-variant="white"
    @hidden="$emit('update:visible', false)"
  >
    <template #modal-header>
      <div class="d-flex justify-content-between align-items-center w-100 pr-4">
        <h5 class="modal-title text-white mb-0">{{ title }}</h5>
        <b-button
          v-if="showExport"
          variant="light"
          size="sm"
          @click="$emit('export')"
          :disabled="isExporting || loading || !items.length"
          class="shadow-sm font-weight-bold"
        >
          <template v-if="isExporting">
            <b-spinner small class="mr-1"></b-spinner>
            Exporting…
          </template>
          <template v-else>
            <i class="fa fa-download mr-1"></i>
            Excel Export
          </template>
        </b-button>
      </div>
    </template>

    <div v-if="loading" class="text-center py-5">
      <b-spinner variant="primary"></b-spinner>
      <p class="text-muted small mt-2 mb-0">Loading…</p>
    </div>
    <div v-else-if="errorMessage" class="alert alert-danger mb-0">{{ errorMessage }}</div>
    <b-table
      v-else
      :items="items"
      :fields="fields"
      hover
      striped
      small
      responsive
      class="mb-0 custom-table"
      show-empty
      empty-text="No records for this range."
    >
      <template slot="index" slot-scope="data">
        {{ (page - 1) * pageSize + data.index + 1 }}
      </template>
      <template slot="status" slot-scope="data">
        <b-badge :variant="getStatusVariant(data.item.status)" pill>
          {{ data.item.status || "N/A" }}
        </b-badge>
      </template>
    </b-table>

    <div v-if="!loading && !errorMessage && total > 0" class="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
      <b-pagination
        v-model="localPage"
        :total-rows="total"
        :per-page="pageSize"
        size="sm"
        @change="$emit('page-change', $event)"
        class="mb-0"
      ></b-pagination>
      <div class="small text-muted font-italic">
        Showing {{ items.length }} of {{ total }} records
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "VehicleUtilizationDrilldownModal",
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: "" },
    fields: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    errorMessage: { type: String, default: "" },
    showExport: { type: Boolean, default: false },
    isExporting: { type: Boolean, default: false },
    total: { type: Number, default: 0 },
    pageSize: { type: Number, default: 10 },
    page: { type: Number, default: 1 },
  },
  data() {
    return {
      localPage: this.page,
    };
  },
  watch: {
    page(newVal) {
      this.localPage = newVal;
    },
  },
  computed: {
    localVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      },
    },
  },
  methods: {
    getStatusVariant(status) {
      if (!status) return "secondary";
      const s = status.toLowerCase();
      if (s === "available") return "success";
      if (s === "booked") return "danger";
      if (s === "inactive") return "dark";
      if (s === "unknown") return "secondary";
      return "primary";
    }
  }
};
</script>

<style scoped>
.custom-table {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// VehicleUtilizationDrilldownModal.vue?56ed0ad2